import { render, staticRenderFns } from "./SidebarBendungan.vue?vue&type=template&id=83499f00&"
import script from "./SidebarBendungan.vue?vue&type=script&lang=js&"
export * from "./SidebarBendungan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports